// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__N8+OR","rotation":"SmallLoader_rotation__CIXvI"};